<template>
  <b-modal
    size="lg"
    centered
    id="modal-add-user"
    hide-footer
    no-close-on-backdrop
    header-class="no-border"
    body-class="no-border"
    modal-class="modalStyle"
    ref="modal-add-user"
  >
    <b-row>
      <b-col>
        <b-form @submit.prevent="handleSubmit">
          <b-row class="ml-4 align-items-center">
            <b-col class="mr-5" lg="2">
              <div class="container-image-user">
                <img
                  v-if="imagePreview"
                  :src="imagePreview"
                  alt="Usuário"
                  class="img-preview-user"
                />
                <b-icon
                  v-else
                  icon="card-image"
                  @click="showActionsImage = !showActionsImage"
                  style="color: #be8250; cursor: pointer"
                  font-scale="4"
                ></b-icon>
              </div>
            </b-col>
            <b-col cols="5" lg="4">
              <b-row>
                <label class="px-2 mb-1" for="name">Nome</label>
              </b-row>
              <b-row>
                <b-form-input
                  id="name"
                  type="text"
                  v-model="user.name"
                  :state="validateState('name')"
                  aria-describedby="input-1-live-feedback"
                  placeholder="Nome Sobrenome"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                  style="font-weight: bold"
                >
                  Campo obrigatório
                </b-form-invalid-feedback>
              </b-row>
            </b-col>
            <b-col class="ml-3 mr-3" cols="5" lg="4">
              <b-row>
                <label class="px-2 mb-1" for="email">Email</label>
              </b-row>
              <b-row>
                <b-form-input
                  id="email"
                  type="text"
                  v-model="user.email"
                  :state="validateState('email')"
                  aria-describedby="input-2-live-feedback"
                  placeholder="Digite o email"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-2-live-feedback"
                  style="font-weight: bold"
                >
                  Campo obrigatório
                </b-form-invalid-feedback>
              </b-row>
            </b-col>
          </b-row>
          <transition name="fade" mode="out-in">
            <b-row
              class="ml-4 mt-2 justify-content-start"
              v-if="showActionsImage"
            >
              <div class="area-options-image-users">
                <div class="mb-1" style="border-bottom: 1px solid #615f5f">
                  <label for="user-image" class="custom-file-upload">
                    <b-icon
                      icon="plus-circle-fill"
                      style="color: #333333"
                    ></b-icon>
                    Adicionar Imagem
                  </label>
                  <input
                    id="user-image"
                    @input="onFileSelected"
                    type="file"
                    accept="image/*"
                  />
                </div>
                <button class="mb-1" type="button" @click="removeImage()">
                  <b-icon
                    class="mr-1"
                    icon="dash-circle-fill"
                    style="color: #333333"
                  ></b-icon>
                  Remover Imagem
                </button>
              </div>
            </b-row>
          </transition>
          <b-row class="mt-4 justify-content-end">
            <b-col cols="auto">
              <b-row>
                <b-col>
                  <b-button class="button btn-cancel" @click="cancel()"
                    >Cancelar</b-button
                  >
                </b-col>
                <b-col>
                  <b-button type="submit" class="button btn-save">
                    Salvar
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <ModalConfirmUser
      ref="modalConfirmUser"
      @responseModalConfirmUser="confirmSubmit($event)"
    />
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalConfirmUser from './ModalConfirmUser.vue';
import { AddUser } from '../../services/Users';
import showError from '../../utils/showError';

export default {
  components: { ModalConfirmUser },
  mixins: [validationMixin],
  data() {
    return {
      showActionsImage: false,
      imagePreview: null,
      user: {
        image: null,
        name: null,
        email: null,
        nivel: 'admin',
      },
    };
  },
  validations: {
    user: {
      name: {
        required,
      },
      email: {
        required,
      },
    },
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0];
      this.user.image = file;

      if (this.user.image) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removeImage() {
      this.imagePreview = null;
      this.user.image = null;
      this.showActionsImage = false;
    },
    validateState(field) {
      const { $dirty, $error } = this.$v.user[field];
      return $dirty ? !$error : null;
    },
    handleSubmit() {
      this.$v.user.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.$refs.modalConfirmUser.isConfirm = true;
      this.$bvModal.show('modal-confirm-user');
    },
    cancel() {
      this.$refs.modalConfirmUser.isConfirm = false;
      this.$bvModal.show('modal-confirm-user');
    },
    async confirmSubmit(confirm) {
      if (confirm) {
        const form = new FormData();
        form.append('image', this.user.image);
        form.append('name', this.user.name);
        form.append('email', this.user.email);
        form.append('nivel', this.user.nivel);

        await AddUser(form)
          .then(() => {
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              this.$router.go(0);
            }, 1000);
          })
          .catch(showError);
      }
      this.resetForm();
    },
    resetForm() {
      this.user = {
        image: null,
        name: null,
        email: null,
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.imagePreview = null;
      this.$bvModal.hide('modal-add-user');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}

::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #be8250;
  border-radius: 20px;
  color: #eeeeee;
}

::v-deep button.close {
  color: #eeeeee;
  outline: none;
}

.container-image-user {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
}

.img-preview-user {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.button {
  height: 32px;
  border-radius: 22px;
  border: none;
  width: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-cancel {
  color: #be8250;
  background-color: #ffffff;
}
.btn-save {
  color: #ffffff;
  background-color: #169933;
  margin-left: 18px;
}

input {
  background: #eeeeee;
  border-radius: 11px;
}

input[type='file'] {
  display: none;
}

.area-options-image-users {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 7px;
  color: #615f5f;
  background-color: #eeeeee;
  width: 145px;
  padding: 2px 6px;
  text-align: center;
  border-radius: 8px;
}

.custom-file-upload:hover {
  cursor: pointer;
}

.area-options-image-users button {
  color: #615f5f;
  border: none;
}

.area-options-image-users button:focus {
  outline: none;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
</style>
